enum IExportOptions {
    OnlyAccepted = 0,
    AcceptedAndTentative = 1,
    All = 2,
}

export default IExportOptions;


// WEBPACK FOOTER //
// ./src/interfaces/IExportOptions.ts